import { combineReducers } from 'redux'

import viewChangeControl from './viewChangeControl'
import quickAddProduct from './quickAddProduct'

export default combineReducers({
  quickAddProduct,
  viewChangeControl,
})
